export const LOAD_STORE_ACTIONS = {
  REQUESTED: 'edit/store/load/required',
  SUCCEEDED: 'edit/store/load/succeeded',
  FAILED: 'edit/store/load/failed',
};

export const EDIT_STORE_ACTIONS = {
  REQUESTED: 'edit/store/required',
  SUCCEEDED: 'edit/store/succeeded',
  FAILED: 'edit/store/failed',
};

export const loadStoreRequested = (storeId: any) => ({
  type: LOAD_STORE_ACTIONS.REQUESTED,
  payload: { storeId },
});

export const loadStoreSucceeded = (store: any) => ({
  type: LOAD_STORE_ACTIONS.SUCCEEDED,
  payload: { store },
});

export const loadStoreFailed = (error: any) => ({
  error,
  type: LOAD_STORE_ACTIONS.FAILED,
});

export const editStoreRequested = (store: any, file: any) => ({
  type: EDIT_STORE_ACTIONS.REQUESTED,
  payload: { store, file },
});

export const editStoreSucceeded = () => ({
  type: EDIT_STORE_ACTIONS.SUCCEEDED,
});

export const editStoreFailed = (error: any) => ({
  error,
  type: EDIT_STORE_ACTIONS.FAILED,
});



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/actions.ts